export const SELECTED_TEAM_COOKIE_NAME = 'selected_team'
